import type { Endpoint } from '@/redux/services/endpoints';

const endpointsWithTranslations: Partial<Record<Endpoint, string>> = {
  getManageCustomers:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorWhileRetrievingOrganizationCustomers',
  getAvailableSubscriptionRoles:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorWhileRetrievingAvailableSubscriptionRoles',
  getOrganizationActiveSubscriptions:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorWhileRetrievingOrganizationAvailableSubscriptions',
  getOrganizationStatistics:
    'Plugins.Misc.SDTheme.Customer.Statistics.ErrorWhileRetrievingStatistics',
  addCustomersToSubscriptions:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorProcessingRequest',
  removeCustomersFromSubscriptions:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorProcessingRequest',
  getCustomerAvailableSubscriptions:
    'Plugins.Misc.SDTheme.SubscriptionOverview.ErrorWhileRetrievingCustomerAvailableSubscriptions',
  assignSubscriptionCustomerRole:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorProcessingRequest',
  removeCustomersFromOrganization:
    'Plugins.Misc.SDTheme.Customer.ManageUsers.ErrorProcessingRequest',
  createCompanyWithOrgUser:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileCreatingUser',
  createCompanyWithoutOrgUser:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileCreatingUser',
  createPrivateUser:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileCreatingUser',
  createStudentUser:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileCreatingUser',
  getCountries:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileRetrievingCountries',
  getCompanies:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileRetrievingCompanies',
  getSchools:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileRetrievingSchools',
  getApiCustomerregistrationTopic:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileRetrievingTermsAndConditions',
  resendActivationLink:
    'Plugins.Misc.SDTheme.Customer.Registration.ErrorWhileResendingActivationLink',
  search: 'Plugins.Misc.SDTheme.Search.ErrorWhileRetrievingItems',
};

export default endpointsWithTranslations;
